import { useEffect } from 'react';
import { sessionStore } from '@bg-shared/business/Session';
import { selectedChipStore } from '../store';

export const useDefaultChipAmount = (): void => {
    useEffect(() => {
        if (
            !selectedChipStore.value ||
            !sessionStore.chipAmounts.includes(selectedChipStore.value)
        ) {
            selectedChipStore.update(sessionStore.defaultChipAmount ?? sessionStore.chipAmounts[0]);
        }
    }, []);
};
